import React, { useState } from 'react';
import { Bell, BellRing, X } from 'lucide-react';
import { usePushNotifications } from '../hooks/usePushNotifications';

const NotificationBell = ({ userEmail }) => {
  const { isSubscribed, permission, subscribe } = usePushNotifications(userEmail);
  const [showPrompt, setShowPrompt] = useState(false);

  const handleClick = async () => {
    if (isSubscribed) return;

    if (permission === 'denied') {
      setShowPrompt(true);
      return;
    }

    const success = await subscribe();
    if (success) {
      setShowPrompt(false);
    }
  };

  if (!('Notification' in window) || !('serviceWorker' in navigator)) return null;

  return (
    <div style={{ position: 'relative' }}>
      <button
        data-testid="notification-bell"
        onClick={handleClick}
        className="notification-bell-btn"
        style={{
          background: isSubscribed ? 'var(--brand-hover)' : 'var(--bg-overlay)',
          border: isSubscribed ? '1px solid var(--brand-primary)' : '1px solid var(--border-subtle)',
          borderRadius: '10px',
          padding: '8px',
          cursor: 'pointer',
          color: isSubscribed ? 'var(--brand-primary)' : 'var(--text-muted)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.2s',
          position: 'relative'
        }}
        title={isSubscribed ? 'Notifications enabled' : 'Enable notifications'}
      >
        {isSubscribed ? <BellRing size={18} /> : <Bell size={18} />}
        {!isSubscribed && (
          <span style={{
            position: 'absolute',
            top: '-2px',
            right: '-2px',
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            background: '#FF4D6A',
          }} />
        )}
      </button>

      {showPrompt && permission === 'denied' && (
        <div style={{
          position: 'absolute',
          top: '100%',
          right: 0,
          marginTop: '8px',
          padding: '12px 16px',
          borderRadius: '12px',
          background: 'var(--bg-card)',
          border: '1px solid var(--border-subtle)',
          backdropFilter: 'blur(12px)',
          width: '240px',
          zIndex: 100,
          fontSize: '13px',
          color: 'var(--text-secondary)',
          lineHeight: 1.5,
          boxShadow: '0 4px 16px rgba(0,0,0,0.15)'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
            <span style={{ fontWeight: 600, color: 'var(--text-primary)' }}>Notifications Blocked</span>
            <button onClick={() => setShowPrompt(false)} style={{ background: 'none', border: 'none', color: 'var(--text-primary)', cursor: 'pointer', padding: 0 }}>
              <X size={14} />
            </button>
          </div>
          Please enable notifications in your browser settings to receive visa status updates.
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
